import { useCallback, useState } from 'react';
import { GetAttachmentDownloadUrlInputSchema } from '@casetrace/shared';
import { getAttachmentDownloadUrl } from '../../lib/callables';
import { downloadUrlAsFile } from './download-blob';

export function useAttachmentDownload() {
  const [downloadingSourceItemId, setDownloadingSourceItemId] = useState<string | null>(null);
  const [downloadError, setDownloadError] = useState<string | null>(null);

  const downloadAttachment = useCallback(async (caseId: string, sourceItemId: string) => {
    setDownloadingSourceItemId(sourceItemId);
    setDownloadError(null);
    try {
      const input = GetAttachmentDownloadUrlInputSchema.parse({
        caseId,
        sourceItemId,
        disposition: 'attachment',
      });
      const result = await getAttachmentDownloadUrl(input);
      await downloadUrlAsFile(result.url, result.fileName);
    } catch (error) {
      setDownloadError(
        error instanceof Error ? error.message : 'Kunne ikke hente nedlastingslenke.',
      );
    } finally {
      setDownloadingSourceItemId(null);
    }
  }, []);

  return { downloadingSourceItemId, downloadError, downloadAttachment };
}
